import { useState } from 'react'
import Fuse from 'fuse.js'
import { useDeepCompareEffect } from 'react-use'
import { Fuzzy } from '@utils/fuse-search'

export function useFuzzySearch<T>({
  collection,
  term,
  keys,
  threshold,
  options,
  setTerm,
}: {
  collection: T[]
  term: string
  keys: string[]
  threshold?: number
  options?: Fuse.IFuseOptions<T>
  setTerm?: (term: string) => void
}): [(term: string) => void, T[] | null] {
  const [results, setResults] = useState<T[] | null>(null)

  useDeepCompareEffect(() => {
    const results = fuzzySearch(collection, term)
    setResults(results)
  }, [collection])

  return [executeSearch, results]

  function executeSearch(term: string): void {
    if (!term) {
      setTerm?.(term)
      setResults(null)
    } else {
      const results = fuzzySearch(collection, term)
      setTerm?.(term)
      setResults(results)
    }
  }

  function fuzzySearch(collection: T[], term: string): T[] {
    const fuzzy = new Fuzzy(collection, { keys, ...options }, threshold)
    return fuzzy.search(term)
  }
}
